import { useEffect, useState } from "react";
import { api } from "./api";

export const useContent = (collection, params = "") => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    setLoading(true);
    api.get(`/content/${collection}${params}`)
      .then((r) => { if (active) setData(r.data || []); })
      .catch(() => { if (active) setData([]); })
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [collection, params]);
  return { data, loading };
};

export const useSettings = () => {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setS(r.data || {})).catch(() => {}); }, []);
  return s;
};
